import 'url-search-params-polyfill'

export function setQuery(obj: {
  [index: string]: string
}){
  const p = new URLSearchParams(window.location.search)
  for(const key in obj){
    p.set(key, obj[key])
  }
  return window.location.href.replace(window.location.search, `?${p.toString()}`)
}

export function getQuery(key: string, defaultValue = "", state = 2){
  if(state === 1){
    console.log(defaultValue)
    const p = new URLSearchParams(window.location.search)
    console.log(p.get(key))
    // console.log(p.get(key))
    // console.log(defaultValue)
    return p.get(key) || defaultValue
  }
  const p = new URLSearchParams(window.location.search)
  return p.get(key) || defaultValue
}

export function getAllQuery(key: string){
  const p = new URLSearchParams(window.location.search)
  const res:{
    [index: string]: string | undefined
  } = {}
  for(const key in p){
    res[key] = p.get(key) || undefined
  }
  return res
}

export const checkEnvironment  = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if(ua.includes('android')) {
      return 'andorid'
  }else if(ua.includes('iphone') || ua.includes('ipad') || ua.includes('mac')) {
      return 'ios'
  }
}